import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'
import { useNavigate } from 'react-router-dom'
import { useModal } from '../components/Modal'

export default function ContractsPage() {
  const { showAlert, ModalComponents } = useModal()
  const [contracts, setContracts] = useState([])
  const [divisions, setDivisions] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [filterDivision, setFilterDivision] = useState('')
  const [filterStatus, setFilterStatus] = useState('')
  const [filterType, setFilterType] = useState('')
  const [filterYear, setFilterYear] = useState('')
  const [pagination, setPagination] = useState({})
  const [downloadingId, setDownloadingId] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    fetchContracts()
    fetchDivisions()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filterDivision, filterStatus, filterType, filterYear])

  const fetchContracts = async () => {
    try {
      setLoading(true)
      const params = { limit: 100 }
      if (search) params.search = search
      if (filterDivision) params.division_id = filterDivision
      if (filterStatus) params.status = filterStatus
      if (filterType) params.emp_type = filterType
      if (filterYear) params.year = filterYear
      const res = await api.get('/contracts', { params })
      if (res.data.success) {
        setContracts(res.data.data)
        setPagination(res.data.pagination)
      }
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const fetchDivisions = async () => {
    try {
      const res = await api.get('/divisions')
      if (res.data.success) setDivisions(res.data.data)
    } catch (err) { console.error(err) }
  }

  const statusConfig = {
    pending:         { label: 'รอพนักงานเซ็น',  color: '#f59e0b', bg: '#fef9c3' },
    signed:          { label: 'รอพยาน 1',        color: '#3b82f6', bg: '#eff6ff' },
    witness1_signed: { label: 'รอพยาน 2',        color: '#2563c5', bg: '#eff6ff' },
    approved:        { label: 'รอนายกลงนาม',     color: '#8b5cf6', bg: '#f5f3ff' },
    completed:       { label: 'เสร็จสมบูรณ์',    color: '#22c55e', bg: '#f0fdf4' },
    ended:           { label: 'สิ้นสุดก่อนกำหนด', color: '#ef4444', bg: '#fef2f2' },
    rejected:        { label: 'ยกเลิก',           color: '#ef4444', bg: '#fef2f2' },
  }

  const handleDownloadPDF = async (contractId, contractNo) => {
    try {
      setDownloadingId(contractId)
      const res = await api.get(`/contracts/${contractId}/pdf`, { responseType: 'blob' })
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `contract_${contractNo.replace('/', '_')}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      showAlert('error', 'เกิดข้อผิดพลาด', 'ไม่สามารถดาวน์โหลด PDF ได้')
    } finally { setDownloadingId(null) }
  }

  const currentYear = new Date().getFullYear() + 543
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i)

  const inputStyle = { padding: '8px 12px', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', color: '#0f172a', background: 'white', outline: 'none', fontFamily: 'inherit' }

  return (
    <Layout>
      <ModalComponents />
      <div className="ice-list-page" style={{ maxWidth: '1400px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
          <div>
            <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>สัญญาทั้งหมด</h1>
            <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>
              {pagination.total ? `พบ ${pagination.total} สัญญา` : 'รายการสัญญาทั้งหมด'}
            </p>
          </div>
          <button onClick={() => navigate('/contracts/create')}
            style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 18px', background: '#075dcc', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
            <i className="ti ti-plus" style={{ fontSize: '16px' }} />
            สร้างสัญญาใหม่
          </button>
        </div>

        {/* Filters */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '16px', marginBottom: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ position: 'relative', flex: '1', minWidth: '200px' }}>
            <i className="ti ti-search" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px', color: '#94a3b8' }} />
            <input type="text" placeholder="ค้นหาชื่อ หรือเลขสัญญา..."
              value={search} onChange={e => setSearch(e.target.value)}
              style={{ ...inputStyle, paddingLeft: '34px', width: '100%' }} />
          </div>
          <select value={filterDivision} onChange={e => setFilterDivision(e.target.value)} style={inputStyle}>
            <option value="">กองงานทั้งหมด</option>
            {divisions.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <select value={filterType} onChange={e => setFilterType(e.target.value)} style={inputStyle}>
            <option value="">ประเภททั้งหมด</option>
            <option value="ทั่วไป">ทั่วไป</option>
            <option value="ตามภารกิจ">ตามภารกิจ</option>
            <option value="ผู้เชี่ยวชาญพิเศษ">ผู้เชี่ยวชาญพิเศษ</option>
          </select>
          <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={inputStyle}>
            <option value="">สถานะทั้งหมด</option>
            <option value="pending">รอพนักงานเซ็น</option>
            <option value="signed">รอพยานลงนาม</option>
            <option value="approved">รอนายกลงนาม</option>
            <option value="ended">สิ้นสุดสัญญาก่อนกำหนด</option>
            <option value="completed">เสร็จสมบูรณ์</option>
            <option value="rejected">ยกเลิก</option>
          </select>
          <select value={filterYear} onChange={e => setFilterYear(e.target.value)} style={inputStyle}>
            <option value="">ปีทั้งหมด</option>
            {years.map(y => <option key={y} value={y - 543}>{y}</option>)}
          </select>
        </div>

        {/* Table */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด...</div>
          ) : contracts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px' }}>
              <i className="ti ti-file-off" style={{ fontSize: '48px', color: '#e2e8f0', display: 'block', marginBottom: '12px' }} />
              <p style={{ color: '#94a3b8', fontSize: '13px', marginBottom: '12px' }}>ยังไม่มีสัญญา</p>
              <button onClick={() => navigate('/contracts/create')}
                style={{ fontSize: '13px', color: '#075dcc', background: 'none', border: 'none', cursor: 'pointer' }}>
                สร้างสัญญาใหม่
              </button>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['เลขสัญญา', 'พนักงาน', 'กองงาน', 'ประเภท', 'วันเริ่ม', 'วันหมด', 'เงินเดือน', 'สถานะ', 'จัดการ'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '10px 16px', fontSize: '11px', color: '#94a3b8', fontWeight: '500', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {contracts.map(c => {
                    const s = c.status === 'completed' && c.termination_date
                      ? { label: 'กำหนดสิ้นสุด', color: '#2563eb', bg: '#eff6ff' }
                      : statusConfig[c.status] || { label: c.status, color: '#64748b', bg: '#f1f5f9' }
                    const isDownloading = downloadingId === c.id
                    return (
                      <tr key={c.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '500', color: '#0f172a', whiteSpace: 'nowrap' }}>{c.contract_no}</td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap' }}>{c.prefix}{c.first_name} {c.last_name}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8' }}>{c.division_name || '-'}</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ display: 'inline-flex', padding: '3px 8px', borderRadius: '999px', fontSize: '11px', background: '#eff6ff', color: '#075dcc' }}>{c.emp_type || '-'}</span>
                        </td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8', whiteSpace: 'nowrap' }}>{new Date(c.start_date).toLocaleDateString('th-TH')}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#94a3b8', whiteSpace: 'nowrap' }}>{new Date(c.end_date).toLocaleDateString('th-TH')}</td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#334155', whiteSpace: 'nowrap' }}>{Number(c.total_salary).toLocaleString('th-TH')} บ.</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ display: 'inline-flex', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: s.color, background: s.bg, whiteSpace: 'nowrap' }}>{s.label}</span>
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <button onClick={() => navigate(`/contracts/${c.id}`)}
                              style={{ padding: '4px 10px', background: '#eff6ff', color: '#075dcc', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>
                              ดู
                            </button>
                            {c.status === 'completed' && !c.termination_date && (
                              <button onClick={() => navigate(`/contracts/create?renew=${c.id}&employee_id=${c.employee_id}&salary=${c.salary}&allowance=${c.allowance || 0}&end_date=${c.end_date}`)}
                                style={{ padding: '4px 10px', background: '#fff7ed', color: '#f97316', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>
                                ต่อสัญญา
                              </button>
                            )}
                            {c.status === 'pending' && (
                              <button onClick={() => navigate(`/contracts/${c.id}/qr`)}
                                style={{ padding: '4px 10px', background: '#f5f3ff', color: '#8b5cf6', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: 'pointer' }}>
                                QR
                              </button>
                            )}
                            {['approved', 'completed', 'ended'].includes(c.status) && (
                              <button onClick={() => handleDownloadPDF(c.id, c.contract_no)} disabled={isDownloading}
                                style={{ padding: '4px 10px', background: '#f0fdf4', color: '#22c55e', border: 'none', borderRadius: '6px', fontSize: '11px', cursor: 'pointer', opacity: isDownloading ? 0.5 : 1 }}>
                                {isDownloading ? '...' : 'PDF'}
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}
